export { ScrollArea } from '@mantine/core'
